import {ArboCreditsLogo} from "pages/Front/Booking/Credits/CreditCalculator/components/icons";
import React from "react";

type CreditsBadgeSize = "sm" | "md" | "lg";

interface CreditsBadgeProps {
    size?: CreditsBadgeSize;
    className?: string;
}

/** Design sizes from Figma: mobile 38, tablet 46, desktop/wide 52. */
const SIZE_PX: Record<CreditsBadgeSize, number> = {
    sm: 38,
    md: 46,
    lg: 52,
};

/** The official Arbo Credits badge (vector extracted from the Figma design). */
export function CreditsBadge({size = "md", className = ""}: CreditsBadgeProps) {
    return <ArboCreditsLogo size={SIZE_PX[size]} className={`shrink-0 ${className}`} />;
}
